import React from 'react';
import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { GenerationDataPoint } from '../../types';

interface BarChartProps {
  data: GenerationDataPoint[];
  yLabel?: string;
  color?: string;
  highlightColor?: string;
  unit?: string;
  height?: number;
}

export default function BarChart({
  data,
  yLabel = '',
  color = '#BFDBFE',
  highlightColor = '#2472C8',
  unit = '',
  height = 260,
}: BarChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-text-tertiary text-sm">
        No data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ReBarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EEEEEE" vertical={false} />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 11, fill: '#999999' }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 11, fill: '#999999' }}
          axisLine={false}
          tickLine={false}
          label={yLabel ? { value: yLabel, angle: -90, position: 'insideLeft', offset: 10, style: { fontSize: 11, fill: '#999999' } } : undefined}
        />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #DDDDDD' }}
          formatter={(val: unknown) => [`${val}${unit}`, 'Generation']}
        />
        <Bar dataKey="value" radius={[3, 3, 0, 0]} maxBarSize={36}>
          {data.map((entry, i) => (
            <Cell key={i} fill={entry.highlighted ? highlightColor : color} />
          ))}
        </Bar>
      </ReBarChart>
    </ResponsiveContainer>
  );
}
